module.exports = __webpack_public_path__ + "img/l2stars.89a68154.svg";